import {CreateInstance} from './config'
const DeviceGroupsExcelAPI = CreateInstance('device-groups-excel')
export default DeviceGroupsExcelAPI
